<ng-container>
    <div class="mb-4 flex flex-col items-center justify-center p-4 border border-red-200 bg-red-50 rounded">
        <div class="text-base font-semibold text-red-700 mb-2 flex items-center gap-2">
            <span class="material-icons align-middle">error_outline</span>
            Error loading content
        </div>
        <div class="text-sm text-red-600 mb-3">
            An error occurred while loading this content. Please try again later.
        </div>
        <div class="flex gap-2">
            <button type="button" *ngIf="uncrashEvent?.observers?.length" class="mr-4" mat-flat-button color="primary" (click)="goBack()">Back</button>
            <button type="button" mat-stroked-button color="primary" (click)="refresh()">Refresh</button>
            <button type="button" *ngIf="!reported" mat-stroked-button color="warn" (click)="report()">Report this error</button>
        </div>
    </div>
</ng-container>